'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setContext = exports.timer = exports.sendBeacon = exports.initBoomerang = exports.onBoomerangLoaded = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _config = require('../redux/modules/config');

var _user = require('../redux/modules/user');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var boomerang = function boomerang() {
    return 'BOOMR' in window ? window.BOOMR : false;
};
var getBoomerang = false;
var version = 'DEV';

var onBoomerangLoaded = exports.onBoomerangLoaded = function onBoomerangLoaded() {
    return getBoomerang;
};
var initBoomerang = exports.initBoomerang = function initBoomerang(_ref) {
    var getState = _ref.getState;

    if (!getBoomerang) {
        getBoomerang = new _promise2.default(function (resolve) {
            var bjs = boomerang();
            if (!bjs && document.addEventListener) {
                document.addEventListener('onBoomerangLoaded', function () {
                    resolve(boomerang());
                    return true;
                });
            } else {
                resolve(boomerang());
            }
        }).then(function (bjs) {
            if (!bjs) return {};

            var state = getState();
            var baseUrl = (0, _config.getBaseUrl)(state);
            var env = (0, _config.getDeployment)(state);
            version = (0, _config.getBuildNumber)(state) || version;

            var beacon_url = !!__DEVELOPMENT__ ? 'http://local.liveauctioneers.com:8080/beacon' : 'https://boomcatch-' + env + '.liveauctioneers.com/beacon';
            var domainMatches = baseUrl.match(/https?:\/\/(.*(:[\d]+)?)/i);

            bjs.init({
                autorun: true,
                beacon_type: 'POST',
                beacon_url: beacon_url,
                Continuity: {
                    enabled: true,
                    sendTimeline: false,
                    ttiWaitForHeroImages: '.item-image-primary img',
                    waitAfterOnload: 3000
                },
                Errors: {
                    maxErrors: 0,
                    monitorConsole: false,
                    monitorGlobal: false,
                    monitorNetwork: false,
                    monitorTimeout: false
                },
                History: {
                    auto: true
                },
                log: null,
                site_domain: domainMatches.length > 0 ? domainMatches[1] : 'liveauctioneers.com'
            });

            bjs.subscribe('before_beacon', beforeBeacon(getState));

            return bjs || {};
        });
    }

    return getBoomerang;
};

var sendBeacon = exports.sendBeacon = function sendBeacon(vars) {
    var _boomerang = boomerang(),
        addVar = _boomerang.addVar,
        fireEvent = _boomerang.fireEvent,
        sendBeacon = _boomerang.sendBeacon;

    if (!sendBeacon) return;
    if (vars) addVar((0, _extends3.default)({}, vars), true);

    fireEvent('interaction');
    sendBeacon();
};

var timer = exports.timer = {
    end: function end(name) {
        var flushBeacon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var _getRt = getRt(),
            endTimer = _getRt.endTimer;

        if (endTimer) {
            endTimer(name);

            if (flushBeacon) sendBeacon({ source: name + ' timer' });
        }
    },
    set: function set(name, timestamp) {
        var flushBeacon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        var _getRt2 = getRt(),
            setTimer = _getRt2.setTimer;

        if (setTimer) {
            setTimer(name, timestamp);

            if (flushBeacon) sendBeacon();
        }
    },
    start: function start(name) {
        var _getRt3 = getRt(),
            startTimer = _getRt3.startTimer;

        if (startTimer) startTimer(name);
    }
};

var context = {};
// Adds values to the beacon
var setContext = exports.setContext = function setContext(tags) {
    return context = tags;
};

var getRt = function getRt() {
    var _boomerang2 = boomerang(),
        plugins = _boomerang2.plugins;

    if (!plugins) return {};

    return plugins.RT || {};
};

var beforeBeacon = function beforeBeacon(getState) {
    return function () {
        var _boomerang3 = boomerang(),
            addVar = _boomerang3.addVar;

        if (addVar) {
            var state = getState();
            addVar((0, _extends3.default)({}, context, {
                bidderId: (0, _user.getBidderId)(state),
                highNms: ((0, _user.getUserData)(state) || {}).ANMS >= 4500,
                isLoggedIn: (0, _user.isUserLoggedIn)(state),
                version: version
            }));
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/boomerang.js
// module id = m1tS
// module chunks = 60